import React from "react";
import "./Intro.css"

export default function Intro() {
    return (
        <div id="intro-wrapper">
            <div id="flex-container">
                <h1 className="heading-style"><span className="span-style">Br</span>eaking</h1>
                <h1 className="heading-style"><span className="span-style">Ba</span>d</h1>
                <p>"The universe is random.</p>
                <p> &nbsp; It's not inevitable.</p>
                <p> &nbsp; It's simple chaos."</p>

            </div>

        </div>
    )
}